// "Save as new" for dashboards: suggesting a title and ID for the copy. The rules the copy's title and ID must
// meet are the dashboard form's own (helpers/dashboardValidation.ts).

export const COPY_ID_SUFFIX = '-copy';

/** The title and ID a copy is saved under. */
export interface DashboardCopy {
  title: string;
  dashboardId: string;
}

interface IdOwner {
  dashboardId?: string;
}

const normalised = (id: string): string => id.trim().toLowerCase();

const takenIds = (dashboards: IdOwner[]): Set<string> =>
  new Set(dashboards.map((d) => normalised(d.dashboardId || '')).filter(Boolean));

/** The original's ID with "-copy" on the end (then "-copy-2", "-copy-3", ...) so it clashes with no existing dashboard. */
export const suggestCopyId = (originalId: string, dashboards: IdOwner[]): string => {
  const taken = takenIds(dashboards);
  const base = `${originalId.trim()}${COPY_ID_SUFFIX}`;
  let candidate = base;
  for (let n = 2; taken.has(normalised(candidate)); n += 1) candidate = `${base}-${n}`;
  return candidate;
};

/** "<title> (copy)", cut so it still fits the title limit. */
export const suggestCopyTitle = (title: string, maxLength: number): string => {
  const suffix = ' (copy)';
  const room = Math.max(0, maxLength - suffix.length);
  return `${title.trim().slice(0, room)}${suffix}`;
};
